import { render, staticRenderFns } from "./HistoryCompareTab.vue?vue&type=template&id=6c2df412&scoped=true"
import script from "./HistoryCompareTab.vue?vue&type=script&lang=ts"
export * from "./HistoryCompareTab.vue?vue&type=script&lang=ts"
import style0 from "./HistoryCompareTab.vue?vue&type=style&index=0&id=6c2df412&lang=sass&scoped=true"
import style1 from "./HistoryCompareTab.vue?vue&type=style&index=1&id=6c2df412&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2df412",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2df412')) {
      api.createRecord('6c2df412', component.options)
    } else {
      api.reload('6c2df412', component.options)
    }
    module.hot.accept("./HistoryCompareTab.vue?vue&type=template&id=6c2df412&scoped=true", function () {
      api.rerender('6c2df412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Viewer/HistoryCompareTab.vue"
export default component.exports